import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import { Controller, useFormContext } from 'react-hook-form';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function RHFDateTimePicker({ name, label, helperText }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <DateTimePicker
          label={label}
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message || helperText,
            },
          }}
        />
      )}
    />
  );
}

export default function CallDurationUpdateCard() {
  return (
    <Box
      sx={{
        mt: 2,
        p: 3,
        borderRadius: 1,
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Call Duration
      </Typography>

      {/* Min / Max duration */}
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <RHFTextField
          name="callDurationMin"
          label="Minimum Duration (seconds)"
          type="number"
          fullWidth
          inputProps={{ min: 0 }}
          helperText="Minimum call duration in seconds"
        />
        <RHFTextField
          name="callDurationMax"
          label="Maximum Duration (seconds)"
          type="number"
          fullWidth
          inputProps={{ min: 0 }}
          helperText="Maximum call duration in seconds"
        />
      </Box>

      {/* Call Start / End Time */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontWeight: 500 }}>
          Call Time Window
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <RHFDateTimePicker
              name="callStartTime"
              label="Call Start Time"
              helperText="Optional: restrict calls after this time"
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <RHFDateTimePicker
              name="callEndTime"
              label="Call End Time"
              helperText="Optional: must be after Call Start Time"
            />
          </Box>
        </Box>
      </LocalizationProvider>
    </Box>
  );
}

CallDurationUpdateCard.propTypes = {};
RHFDateTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
};
